/**
 * AvatarsTab — T26.
 * Per-product library editor for the 'avatar' parameter type.
 */
import LibraryEditor from './LibraryEditor';

interface AvatarsTabProps {
  canWrite: boolean;
}

export default function AvatarsTab({ canWrite }: AvatarsTabProps) {
  return <LibraryEditor type="avatar" canWrite={canWrite} perProduct />;
}
